import { Link } from 'react-router-dom';

const POINTS = [
  {
    icon: 'ri-database-2-line',
    title: '丰富影视资料',
    desc: '覆盖电影与电视剧两大类别，作品资料、演职人员与类型标签一目了然。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '多维筛选检索',
    desc: '按类型、地区、年份组合筛选，配合关键词搜索快速定位心仪作品。',
  },
  {
    icon: 'ri-book-open-line',
    title: '观影指南与资讯',
    desc: '定期整理观影指南、幕后制作与行业观察，让你看得更懂一点。',
  },
];

export default function SiteIntro() {
  return (
    <section aria-label="网站简介" className="mt-12 md:mt-16 rounded-lg bg-primary-900 text-primary-100 p-6 md:p-10">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-6 md:gap-10 items-center">
        <div>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-background-50">
            关于快活影院
          </h2>
          <p className="mt-3 text-sm md:text-base leading-relaxed text-primary-200">
            快活影院是一个专注影视内容展示与资讯分享的平台，把散落在各处的作品资料、观影建议与行业动态，
            整理成一份随时可以翻阅的观影地图。
          </p>
          <Link
            to="/about"
            className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm font-semibold transition-colors whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {POINTS.map((point) => (
            <div key={point.title} className="rounded-lg bg-primary-800/60 p-4">
              <span className="w-10 h-10 rounded-md bg-background-50/10 text-accent-400 flex items-center justify-center">
                <i className={`${point.icon} text-xl`}></i>
              </span>
              <h3 className="mt-3 font-heading font-semibold text-sm text-background-50">{point.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-primary-300">{point.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}